import { ReactElement } from "react";
import { Spin } from "antd";
import "./dropdown-loader.scss";

interface DropdownLoaderProps {
  menu: ReactElement;
  isLoading: boolean;
}

export function DropdownLoader({ menu, isLoading }: DropdownLoaderProps) {
  return (
    <>
      {menu}
      <div className="dropdown-loader">
        {isLoading && <Spin />}
      </div>
    </>
  );
}
